import { Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PageLoader } from "@/components/PageLoader";
import { PlatformAdminPage } from "@/components/admin/PlatformAdminPage";
import { PlatformAdminShell } from "@/components/admin/PlatformAdminShell";
import { ADMIN_DOMAIN_NAV, resolveAdminDomain, type AdminTabId } from "@/components/admin/admin-nav";
import { useSession } from "@/hooks/use-session";
import { isPlatformStaffRole } from "@/lib/platform-staff";
import { RenataFloatingButton } from "@/components/renata/RenataFloatingButton";

function RedirectToLogin() {
  useEffect(() => {
    window.location.replace("/acceso/comercio?returnTo=/admin");
  }, []);
  return <PageLoader variant="screen" label="Redirigiendo…" />;
}

export function AdminRoute({ tab }: { tab?: string }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isLoading, logout } = useSession();

  if (isLoading) {
    return <PageLoader variant="screen" label="Verificando acceso…" />;
  }

  if (!user || !isPlatformStaffRole(user.role)) {
    return <RedirectToLogin />;
  }

  // Subrutas /admin/*: shell persistente (ops, partners, etc.) — no desmontar el menú.
  if (location.pathname !== "/admin" && location.pathname.startsWith("/admin/")) {
    const domain = resolveAdminDomain({ pathname: location.pathname, tab });
    const shellTab: AdminTabId =
      ADMIN_DOMAIN_NAV.find((d) => d.id === domain)?.targetTab ?? "dashboard";
    return (
      <>
        <PlatformAdminShell
          tab={shellTab}
          onTabChange={(id) => void navigate({ to: "/admin", search: { tab: id } })}
          userEmail={user.email}
          onLogout={() => logout()}
        >
          <Outlet />
        </PlatformAdminShell>
        <RenataFloatingButton />
      </>
    );
  }

  return (
    <>
      <PlatformAdminPage userEmail={user.email} onLogout={() => logout()} initialTab={tab as AdminTabId | undefined} />
      <RenataFloatingButton />
    </>
  );
}
